import { createContext, useContext, useState, useCallback } from "react";

// User-selectable measurement system. Kept client-side for now (persists per
// browser); when the account/settings + admin slice lands, this lifts to the
// User record so it syncs across devices. format.js reads the plain getter
// below synchronously; React components use the hook so a toggle re-renders.

const KEY = "tm3_units";

let _system = "us"; // module cache, read synchronously by format.js
try {
  const s = localStorage.getItem(KEY);
  if (s === "us" || s === "eu") _system = s;
} catch (e) {}

export function getUnitSystem() {
  return _system;
}

function persist(v) {
  _system = v;
  try {
    localStorage.setItem(KEY, v);
  } catch (e) {}
}

const UnitsCtx = createContext(null);

export function UnitsProvider({ children }) {
  const [system, setSystem] = useState(_system);
  const setUnits = useCallback((v) => {
    persist(v);
    setSystem(v);
  }, []);
  const toggle = useCallback(() => setUnits(_system === "us" ? "eu" : "us"), [setUnits]);
  return (
    <UnitsCtx.Provider value={{ system, setUnits, toggle }}>{children}</UnitsCtx.Provider>
  );
}

export function useUnits() {
  const ctx = useContext(UnitsCtx);
  if (!ctx) throw new Error("useUnits must be used within UnitsProvider");
  return ctx;
}
